import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen bg-charcoal flex items-center justify-center"
      >
        <span className="font-sans text-[11px] tracking-[0.28em] uppercase text-canvas/50">
          Loading…
        </span>
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  return children;
};
